import { getDisplayEmail } from "utils/email";

const EmailDisplay = ({ email }) => <>{getDisplayEmail(email)}</>;

export default EmailDisplay;
